import { Map } from 'immutable'

export function selectPayment (state) {
  const { payment = Map() } = state
  return payment
}

export function selectTokenProcessing (state) {
  const { payment = Map() } = state
  return payment.get('paymentDataProcessing')
}

export function selectPaymentAuthorized (state) {
  const { payment = Map() } = state
  const isPaymentProcessing = payment.get('paymentDataProcessing')
  const paymentSuccess = payment.getIn(['data', 'payments', 'success']) === true
    && payment.getIn(['data', 'payments', 'error']) !== true
  if (isPaymentProcessing) return false
  return paymentSuccess
}
